import { useState } from "react";

import { Form } from "react-bootstrap";

const ParameterNameField = ({
  id,
  name,
  takenNames,
  onRename,
  "aria-label": ariaLabel,
}: {
  id: string;
  name: string;
  takenNames: Set<string>;
  onRename: (next: string) => void;
  "aria-label": string;
}) => {
  const [draft, setDraft] = useState<string | null>(null);
  return (
    <Form.Control
      id={id}
      className="font-monospace"
      aria-label={ariaLabel}
      autoComplete="off"
      autoCorrect="off"
      autoCapitalize="off"
      spellCheck={false}
      value={draft ?? name}
      isInvalid={draft !== null}
      onChange={(event) => {
        const next = event.target.value;
        if (next === name) {
          setDraft(null);
          return;
        }
        if (next === "" || takenNames.has(next)) {
          setDraft(next);
          return;
        }
        setDraft(null);
        onRename(next);
      }}
      onBlur={() => setDraft(null)}
      data-testid={id}
    />
  );
};

export default ParameterNameField;
